import React, { FunctionComponent } from 'react'
import Button from '@material-ui/core/Button'
import Table from '@material-ui/core/Table'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Container from '@material-ui/core/Container'
import Tooltip from '@material-ui/core/Tooltip'
import IconInfo from '@material-ui/icons/InfoOutlined'
import Alert from '@material-ui/lab/Alert'
import { Skeleton } from '@material-ui/lab'
import { withStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { formatTimestamp } from 'utils'
import MinusSquare from '@material-ui/icons/IndeterminateCheckBoxOutlined'
import PlusSquare from '@material-ui/icons/AddBoxOutlined'

const ExpandButton = withStyles({
  label: {
    fontWeight: 500,
  },
  startIcon: {
    marginLeft: 0,
    '& svg': {
      width: 16,
      height: 16,
    },
  },
})(Button)

export const ListSectionTable = withStyles({
  root: {
    '& td, & th': {
      borderBottomColor: 'rgba(224, 224, 224, 0.33)',
    },
    '& tr:last-child td': {
      borderBottom: '0 none',
    },
  },
})(Table)

export const ListSectionDatetime = ({ value }: { value: string }) => {
  const date = new Date(value)

  return <>{formatTimestamp(value)}<small>:{('0' + date.getSeconds()).slice(-2)}</small></>
}

export const orDash = (value: any) => {
  return value == null || value === '' ? '—' : value
}

export const ListSectionSkeletonRow = ({ columns = 3 }: { columns?: number }) => (
  <TableRow>
    {Array.from({ length: columns }).map((_, key) => (
      <TableCell key={key}>
        <Skeleton />
      </TableCell>
    ))}
  </TableRow>
)

export const ListSectionIdCell = ({ id }: { id: number }) => (
  <TableCell align="center" style={{ paddingLeft: 16, paddingRight: 16, width: 62 }}>
    <Tooltip title={`#: ${id}`} placement={'top'} arrow interactive>
      <IconInfo fontSize="small" style={{ verticalAlign: 'middle' }} />
    </Tooltip>
  </TableCell>
)

type ListSectionBodyProps = {
  expand: boolean
  error: string | null
  empty: boolean
}

export const ListSectionBody: FunctionComponent<ListSectionBodyProps> = ({ expand, error, empty, children }) => {
  const { t } = useTranslation()

  if (!expand) {
    return null
  }

  if (error) {
    return (
      <Container maxWidth="md" style={{ marginTop: 10 }}>
        <Alert severity="warning">{error}</Alert>
      </Container>
    )
  }

  if (empty) {
    return (
      <Container maxWidth="md" style={{ marginTop: 10 }}>
        <Alert severity="info">{t('noRecords')}</Alert>
      </Container>
    )
  }

  return (
    <TableContainer>
      <ListSectionTable size="small">{children}</ListSectionTable>
    </TableContainer>
  )
}

type ListSectionExpandButtonProps = {
  expand: boolean
  onClick: () => void
}

export const ListSectionExpandButton: FunctionComponent<ListSectionExpandButtonProps> = ({ expand, onClick, children }) => (
  <ExpandButton
    startIcon={expand ? <MinusSquare /> : <PlusSquare />}
    size={'large'}
    onClick={onClick}
  >{children}</ExpandButton>
)
